// 导航-->中英文
export const certificate = {
    'zhCN': {
        certificate: {
            addCertificateData: '新增补偿证明项目',
            editCertificateData: '编辑补偿证明项目',
            disableCertificateData: '停用补偿证明项目',
            fileName: '补偿项目名称',
            projectName: '项目名称',
            fileNameNull: '补偿项目名称不能为空',
            fileNameLength: '补偿项目名称过长',
            timeLimit: '时间范围',
            status: '状态',
            startTime: '补偿证明开始月份',
            startTimeNull: '补偿证明开始月份不能为空',
            endDate: '补偿证明截止月份',
            deadlineNull: '补偿证明截止月份不能为空',
            startDateAndEndDateVerification: '补偿证明开始月份不能大于补偿证明截止月份',
            templateDownload: '补偿证明项目导入模板下载',
            uploadedBy: '上传人',
            calculationResultData: '计算结果数据',
            confirmCertificateDataCalculation: '计算结果数据后，付款计划不可再进行编辑、停用和删除操作，是否确认？',
            calculatingPaymentPlans: '生成付款计划',
            confirmPaymentPlan: '生成付款计划后，不可再上传基础数据，是否确认？',
            certificate: '补偿证明',
            returnCertificate: '退货证明',
            uploadReturnCertificate: '上传退货证明',
            specialReturnCertificate: '退货证明（特殊需求）',
            dealerName: '流向商业名称',
            dealerNameNull: '流向商业名称不可为空',
            dealerPHCode: '流向商业PHCode',
            PHCode: 'PHCode',
            demandProofCompensation: '补偿证明需求',
            generateAReturnCertificate: '生成退货证明',
            downloadReturnCertificate: '退货证明打包下载（PDF）',
            finalEditDateTime: '修改时间',
            uploadFiles: '上传文件',
            viewUploadFiles: '查看已上传文件',
            whetherSpecialNeeds: '是否特殊需求',
            template: '模板',
            templateNull: '模板不可以为空',
            splitMethod: '拆分方式',
            originalFileName: '文件名称',
            attachmentType: '文件类型',
            replaceFileName: '替换文件名称',
            splitMethodNull: '拆分方式不可以为空',
            whetherProduct: '有无产品',
            whetherProductNull: '有无产品不可以为空',
            whetherClassificationCoding: '是否带税收分类编码',
            compensationCertificationRequirements: '补偿证明要求',
            addReturnRequirement: '新增补偿证明需求',
            editReturnRequirement: '编辑补偿证明需求',
            provinceAndCityNull: '省份/城市不可以为空',
            provinceAndCitySelected: '省份/城市城市未选择',
            provinceName: '省份',
            splitAmount: '拆分金额',
            splitAmountNull: '拆分金额不可以为空',
            splitAmountLength: '拆分金额过长',
            splitAmountValidate: '拆分金额最多九位整数、两位小数',
            paymentPlan: '付款计划',
            editPaymentPlan: '编辑付款计划',
            disablePaymentPlan: '停用付款计划',
            importPaymentPlan: '导入付款计划',
            consignorName: '货主名称',
            materialGroup: '分型',
            productChinese: '产品中文名称',
            amountWithTax: '含税金额(元)',
            taxRate: '税率%',
            warningMessage: '警告说明',
            seal: '批量签章',
            viewSealResult: '查看签章结果',
            confirmSendEmail: '确认发送所有补偿文件？',
            confirmSeal: '确认需要继续批量签章？',
            compensationFilePackageDownload: '补偿文件打包下载',
            confirmCompensationFilePackageDownload: '确认后将打包下载补偿文件',
            collectionAndPaymentDetails: '代收代付明细',
            generateACollectionAndPaymentDetails: '生成代收代付明细',
            downloadCollectionAndPaymentDetails: '代收代付明细打包下载（PDF）',
            downloadFile: '下载文件',
            collectionAndPaymentBusiness: '代收代付商业',
            collectionBusiness: '收款商业',
            excludingTax: '不含税金额(元)',
            tax: '税额(元)',
            totalTaxIncluded: '含税合计(元)',
            confirmGeneration: '确认生成',
            dateOfIssue: '开具日期',
            dateOfIssueNull: '开具日期不可为空',
            collectionAndPaymentInstructions: '代收代付证明',
            generateCollectionAndPaymentInstructions: '生成代收代付证明',
            downloadCollectionAndPaymentInstructions: '代收代付证明打包下载（PDF）',
            collectionAndPaymentAmount: '代收代付金额(元)',
            selfAmount: 'self金额(元)',
            taxClassificationCode: '税收分类编码',
            companyCode: '公司代码',
            whetherDelete: '对应的付款计划，证明文件都将被删除，是否确认？',
            whetherToWarn: '是否警告',
            invoiceType: '发票类型',
            whetherDisable: '是否停用',
            areYouSureDelete: '确定要删除当前文件？',
            areYouSureCancel: '确定要作废当前商业公司的补偿文件？',
            areYouSureReplace: '确定要替换补偿文件？',
            whetherAbnormal: '是否异常',
            exceptionDescription: '异常说明',
            lastSendTime: '最后发送时间',
            sales: '销量',
            tierSuccess: '选择的付款计划不能为同一商业，请重新选择',
            IncludingTaxPriceValidate: '含税金额最多九位整数、四位小数',
            taxRateValidate: '税率最多九位整数、两位小数',
            salesQuantityValidate: '请输入0~100之间且包括100的数',
            uploadFormatError: '仅支持xlsx格式的文件',
            uploadFormatJPGError: '仅支持JPG格式的文件',
            uploadFormatPDFError: '仅支持PDF格式的文件',
            uploadMaxSizeError: '超出上传文件最大限制，文件不能超过10M.',
            confirmPaymentPlanSuccess: '生成付款计划成功',
            certificateDataCalculationSuccess: '计算结果数据成功',
            HasUploadSpecialFileWarning: '该流向商业已经上传过特殊需求退货证明',
            finaflSendTime: '最后发送时间',
            confirmCollectionAndPaymentDetailse: '只能生成一次代收代付明细，是否继续生成？',
            createReturnCertificatePDF: '只能生成一次退货证明，是否继续生成？',
            generateCollectPaymentCertificate: '只能生成一次代收代付证明，是否继续生成？',
            saveCollectionAndPaymentDetailsSuccess: '代收代付明细正在后台生成中，请耐心等候',
            saveGenerateCollectPaymentCertificateSuccess: '代收代付证明正在后台生成中，请耐心等候',
            generateContrast: '生成对比',
            repeatNumber: '重复数',
            contrastStatus: '对比状态',
            compareResults: '对比结果',
            batch: '批次',
            paymentPlanCompared: '付款计划差异对比',
            pdfFileIsNotGenerated: 'PDF文件未生成',
            confirmAll: '确认现付款计划',
            giveUpAll: '放弃现付款计划',
            originalPaymentPlan: '系统付款计划',
            originalAmountWithTax: '原含税金额(元)',
            originalTaxRate: '原税率%',
            presentriginalPaymentPlan: '现付款计划',
            presentriginalAmountWithTax: '现含税金额(元)',
            presentriginalTaxRate: '现税率%',
            differenceDescription: '差异说明',
            overwriteExistingPaymentPlan: '确认以本批次上传的数据覆盖系统中所有存在的付款计划数据？',
            keepExistingPaymentPlan: '将会放弃本次上传所有数据数据，是否继续确认？',
            confirmSendEmailSuccess: '邮件发送成功',
            createReturnCertificateSuccess: '退货证明正在后台生成中，请耐心等候',
            distributorEmployeeName: '流向商业负责人',
            distributorEmployeeEmail: '负责人邮箱',
            uploadCompensationCertificateSpecial: '上传附件后才可以保存',
            whetherCompare: '待对比的文件中没有通过验证的数据，是否确认对比？',
            loadingName: '正在生成证明文件',
            loadingData: '证明文件正在创建…… 请稍后',
            hasWaitGenerateFile: '项目存在等待生成的文件,请稍后查看结果',
            hasGenerateFile: '项目正在生成文件,请稍后查看结果',
            hasGenerateError: '项目生成证明文件异常，请联系管理员',
            isWarning: '是否警告',
            comment: '备注',
            commentOfDelete: '删除原因',
            commentOfCancel: '作废原因',
            correct: '折算',
            stop: '停用',
            correctReturnCertificate: '折算退货证明',
            correctMaterialGroup: '折算产品(含税合计(元))',
            correctRequiredMessage: '请选择一个折算产品',
            disableReturnCertificate: '停用退货证明',
            disableReturnCertificateDetail: '停用退货证明明细',
            fileStatusDesc: '文件生成情况',
            paymentLog: '付款计划上传记录',
            amountTotalWithTax: '含税合计(元)',
            sealResult: '签章结果',
            signStatus: '签章状态',
            fileStatus: '文件状态',
            hasRelease: '是否已发布',
            releaseData: '发布数据',
            syncDataToSno: '推送到SODA',
            signDesc: '签章情况',
            invoiceNoticeStatus: '发票通知书',
            release: '发布',
            reSign: '重新签章',
            cancel: '作废',
            replaceNewFile: '替换新文件',
            approvelNotice: '审核通知书',
            downloadNotice: '下载通知书',
            editNotice: '编辑通知书',
            contractNumber: '合同号',
            statusOfContractInBill: '订单中状态',
            mailSendStatus: '邮件发送状态',
            commentOfDeleteNull: '删除原因不可为空',
            commentOfCancelNull: '作废原因不可为空',
            startSeal: '开始批量签章，请耐心等待。',
            releaseSuccess: '发布成功',
            confirmRelease: ',是否确认发布?',
            areYouSureReSign: '确定要重新签章？',
            noticeName: '红票通知书名称',
            resendEmail: '重发邮件',
            invoiceNoticeApproval: '红字发票通知书审核',
            companyName: '企业名称',
            invoiceNotice: '红字发票通知书',
            remarkOfApprovedInvoiceNotice: '审核意见',
            noticeFolderName: '发票通知书名称',
            noticeFolderNameNull: '发票通知书目录名称不能为空',
            noticeFolderNameLength: '发票通知书目录名称过长',
            deleteInSealing: '补偿证明文件正在签章，无法删除。',
            deleteInGenerating: '补偿证明文件正在生成，无法删除。',
            atLeastOneFileNeedReplaced: '至少需要替换一个文件，请检查。',
            reSignSuccess: '重新签章成功',
            haveLeastOneAttachment: '至少要有一个红字发票通知书',
            operateSuccess: '操作成功',
            hasWaitingForApproval: '存在待审核的通知书',
            hasnotWaitingForApproval: '不存在待审核的通知书',
            cityName: '城市',
            batchDownloadScope: '下载范围',
            compensationFolder: '补偿文件目录名称',
            whetherRejectInvoiceNotice: '是否确认拒绝？',
            shipperEmpty: '请选择货主',
            paymentPlanTemplateDownload: '付款计划导入模板下载',
            discountCategory: '折让分类',
            sellOutDiscountCategory: 'Sell Out 折让分类',
            sellInDiscountCategory: 'Sell In 折让分类',
            addNewDiscountCategory: '新增折让分类',
            discountCategoryBeEmpty: 'Sell Out 折让分类不能为空',
            sellInDiscountCategoryLength: 'Sell Out 折让分类过长',
            sellInDiscountCategoryBeEmpty: 'Sell In 折让分类不能为空',
            discountCategoryLength: 'Sell In 折让分类过长',
            compensationDiscountBeEmpty: '补偿折扣类型不能为空',
            whetherDeleteDiscountCategory: '是否确认删除折让分类？',
            compensationDiscountType: '补偿折扣类型'
        }
    },
    'enUS': {
        certificate: {
            addCertificateData: 'Add compensation certificate preparation data',
            editCertificateData: 'Edit compensation certificate preparation data',
            disableCertificateData: 'Disable Compensation Certificate Preparation Data',
            fileName: 'Project name',
            projectName: 'Project Name',
            fileNameNull: 'Project name cannot be empty',
            fileNameLength: 'Project name is too long',
            timeLimit: 'Time Range',
            status: 'Status',
            startTime: 'Compensation file start month',
            startTimeNull: 'The start month of the compensation file cannot be empty',
            endDate: 'Finish file deadline month',
            deadlineNull: 'The compensation file deadline month cannot be empty',
            startDateAndEndDateVerification: 'The start month of the compensation file can be greater than the end month of the compensation file',
            templateDownload: 'Compensation certification project import template download',
            uploadedBy: 'Uploaded by',
            calculationResultData: 'Calculation result data',
            confirmCertificateDataCalculation: 'After calculating the result data, the payment plan can no longer be edited, deactivated and deleted? ',
            calculatingPaymentPlans: 'Generate Payment Plan',
            confirmPaymentPlan: 'After generating a payment plan, the basic data can no longer be uploaded. Are you sure? ',
            certificate: 'Certificate of Compensation',
            returnCertificate: 'Certificate of Return',
            uploadReturnCertificate: 'Upload Return Certificate',
            specialReturnCertificate: 'Certificate of Return (Special Needs)',
            dealerName: 'Distributor name',
            dealerNameNull: 'Distributor name cannot be empty',
            dealerPHCode: 'Distributor PHCode',
            PHCode: 'PHCode',
            demandProofCompensation: 'Compensation Proof Demand',
            generateAReturnCertificate: 'Generate Return Certificate',
            downloadReturnCertificate: 'Packed Download Certificate of Return (PDF)',
            finalEditDateTime: 'Modified time',
            uploadFiles: 'Upload Files',
            viewUploadFiles: 'View uploaded files',
            whetherSpecialNeeds: 'SpecialNeeds',
            template: 'Template',
            templateNull: 'Template cannot be empty',
            splitMethod: 'Split method',
            originalFileName: 'File Name',
            attachmentType: 'Attachment Type',
            replaceFileName: 'Replace File Name',
            splitMethodNull: 'Split method cannot be empty',
            whetherProduct: 'Is there a product',
            whetherProductNull: 'Products cannot be empty',
            whetherClassificationCoding: 'Whether tax classification code',
            compensationCertificationRequirements: 'Compensation Certification Requirements',
            addReturnRequirement: 'Add compensation requirement',
            editReturnRequirement: 'Edit compensation proof requirement',
            provinceAndCityNull: 'Province / City cannot be empty',
            provinceAndCitySelected: 'Province / City City Not Selected',
            provinceName: 'Province',
            splitAmount: 'Split Amount',
            splitAmountNull: 'Split amount cannot be empty',
            splitAmountLength: 'The split amount is too long',
            splitAmountValidate: 'Split amount up to nine integers and two decimals',
            paymentPlan: 'Payment Plan',
            editPaymentPlan: 'Edit payment plan',
            disablePaymentPlan: 'Disable payment plan',
            importPaymentPlan: 'Import Payment Plan',
            consignorName: 'Consignor Name',
            materialGroup: 'Parting',
            productChinese: 'Product Chinese Name',
            amountWithTax: 'Tax-included amount (yuan)',
            taxRate: 'Tax rate%',
            warningMessage: 'Warning description',
            viewSealResult: 'Sealed Result',
            seal: 'seal',
            confirmSendEmail: 'Confirm to send all compensation files? ',
            confirmSeal: 'Confirm to seal?',
            compensationFilePackageDownload: 'Compensation File Package Download',
            confirmCompensationFilePackageDownload: 'After confirmation, the compensation file will be downloaded in a package.',
            collectionAndPaymentDetails: 'Collection and Payment Details',
            generateACollectionAndPaymentDetails: 'Generate collection and payment details',
            downloadCollectionAndPaymentDetails: 'Package and download payment details (PDF)',
            downloadFile: 'Download File',
            collectionAndPaymentBusiness: 'Collection and Payment Business',
            collectionBusiness: 'Collection Business',
            excludingTax: 'Excluding tax amount (yuan)',
            tax: 'Tax Amount(yuan)',
            totalTaxIncluded: 'Total tax included (yuan)',
            confirmGeneration: 'Confirm Generation',
            dateOfIssue: 'Issue Date',
            dateOfIssueNull: 'Issue date cannot be empty',
            collectionAndPaymentInstructions: 'Certificate of Collection and Payment',
            generateCollectionAndPaymentInstructions: 'Generate collection and payment certificate',
            downloadCollectionAndPaymentInstructions: 'Package Download Certificate (PDF)',
            collectionAndPaymentAmount: 'Collection and payment amount (yuan)',
            selfAmount: 'Self amount (yuan)',
            taxClassificationCode: 'Tax Classification Code',
            companyCode: 'Company Code',
            whetherDelete: 'The corresponding payment plan and supporting documents will be deleted. Are you sure? ',
            whetherToWarn: 'Whether to warn',
            invoiceType: 'Invoice Type',
            whetherDisable: 'Disabled',
            areYouSureDelete: 'Are you sure you want to delete?',
            areYouSureCancel: 'Are you sure you want to Cancel?',
            areYouSureReplace: 'Are you sure you want to replace?',
            whetherAbnormal: 'Abnormal',
            exceptionDescription: 'Exception Description',
            lastSendTime: 'Last Send Time',
            sales: 'Sales',
            tierSuccess: 'The selected payment plan cannot be the same business, please select again',
            IncludingTaxPriceValidate: 'Up to nine integers and four decimals including tax amount',
            taxRateValidate: 'Tax rate up to nine integers and two decimals',
            salesQuantityValidate: 'Please enter a number between 0 and 100, including 100',
            uploadFormatError: 'Only files in xlsx format are supported',
            uploadFormatJPGError: 'Only files in JPG format are supported',
            uploadFormatPDFError: 'Only files in PDF format are supported',
            uploadMaxSizeError: 'Exceeding file size limit, no more than 10M.',
            confirmPaymentPlanSuccess: 'Successfully generated payment plan',
            certificateDataCalculationSuccess: 'Calculation result data succeeded',
            HasUploadSpecialFileWarning: 'The flow business has uploaded a special needs return certificated',
            finaflSendTime: 'Last Send Time',
            confirmCollectionAndPaymentDetailse: 'The collection and payment details can only be generated once. Will it continue to be generated?',
            createReturnCertificatePDF: 'The return certificate can only be generated once. Will it continue to be generated?',
            generateCollectPaymentCertificate: 'Only one collection and payment certificate can be generated. Will it continue to be generated?',
            saveCollectionAndPaymentDetailsSuccess: 'Collection and payment details are successfully generated in the background, please wait patiently',
            generateContrast: 'Generate Contrast',
            saveGenerateCollectPaymentCertificateSuccess: 'The collection and payment certificate has been generated in the background, please wait patiently',
            repeatNumber: 'Repeat number',
            contrastStatus: 'Contrast Status',
            compareResults: 'Compare results',
            batch: 'Batch',
            paymentPlanCompared: 'Comparison of payment plan differences',
            pdfFileIsNotGenerated: 'PDF file is not generated',
            confirmAll: 'Confirm cash plan',
            giveUpAll: 'Abandon cash plan',
            originalPaymentPlan: 'System payment plan',
            originalAmountWithTax: 'Original Amount With Tax (yuan)',
            originalTaxRate: 'Original Tax Rate%',
            presentriginalPaymentPlan: 'Cash Payment Plan',
            presentriginalAmountWithTax: 'present tax amount (yuan)',
            presentriginalTaxRate: 'Current Tax Rate%',
            differenceDescription: 'Difference description',
            overwriteExistingPaymentPlan: 'Make sure to cover all existing payment plan data in the system with the data uploaded in this batch?',
            keepExistingPaymentPlan: 'Will give up all the data upload this time, continue to confirm?',
            confirmSendEmailSuccess: 'Mail sent successfully',
            createReturnCertificateSuccess: 'The return certificate is being generated in the background, please wait patiently',
            distributorEmployeeName: 'principal',
            distributorEmployeeEmail: 'Person in charge',
            uploadCompensationCertificateSpecial: 'Only upload attachments before saving',
            whetherCompare: 'There is no verified data in the documents to be compared. Do you want to confirm the comparison?',
            loadingName: 'Generating document',
            loadingData: 'Proof document is being created ... please wait',
            hasWaitGenerateFile: 'The compensation certificate has wait generate file,please wait',
            hasGenerateFile: 'The compensation certificate is being generate file,please wait',
            hasGenerateError: 'The compensation certificate  generate file error ,please wait',
            isWarning: 'IsWarning',
            comment: 'Comment',
            commentOfDelete: 'Comment Of Delete',
            correct: 'Correct',
            stop: 'Stop',
            correctReturnCertificate: 'Correct Return Certificate',
            correctMaterialGroup: 'Correct MaterialGroup(AmountTotalWithTax(yuan))',
            correctRequiredMessage: 'Please select a discount product',
            disableReturnCertificate: 'Disable Return Certificate',
            disableReturnCertificateDetail: 'Disable Return Certificate Detail',
            fileStatusDesc: 'File Generate Description',
            paymentLog: 'Payment Plan Upload Log',
            amountTotalWithTax: 'AmountTotalWithTax(yuan)',
            sealResult: 'Seal Result',
            signStatus: 'Sign Status',
            fileStatus: 'File Status',
            hasRelease: 'Has Release',
            releaseData: 'Release Data',
            syncDataToSno: 'Sync Data to Sno',
            signDesc: 'Sign Desc',
            invoiceNoticeStatus: 'Notice Status',
            release: 'Release',
            reSign: 'Re Sign',
            cancel: 'Cancel',
            replaceNewFile: 'Replace New File',
            approvelNotice: 'Approval Notice',
            downloadNotice: 'Download Notice',
            editNotice: 'Edit Notice',
            contractNumber: 'Contract Number',
            statusOfContractInBill: 'Status in Order',
            mailSendStatus: 'Mail Send Status',
            startSeal: 'Start batch signature, please wait。',
            commentOfDeleteNull: 'Required',
            commentOfCancelNull: 'Required',
            releaseSuccess: 'Release success',
            confirmRelease: ',Confirm Release?',
            areYouSureReSign: 'Confirm resign？',
            noticeName: 'Notice Name',
            resendEmail: 'Resend Mail',
            invoiceNoticeApproval: 'Invoice Notice Approval',
            companyName: 'Company Name',
            invoiceNotice: 'Invoice Notice',
            remarkOfApprovedInvoiceNotice: 'Remark Of Approved Invoice Notice',
            noticeFolderName: 'Notice FolderName',
            noticeFolderNameNull: 'Notice foldername can not be empty',
            noticeFolderNameLength: 'Notice foldername to length',
            deleteInSealing: 'The compensation certificate is being signed and cannot be deleted。',
            deleteInGenerating: 'The compensation certificate is being generated and cannot be deleted。',
            atLeastOneFileNeedReplaced: 'At least one file needs to be replaced, please check。',
            reSignSuccess: 'Re sign Success',
            haveLeastOneAttachment: 'There must be at least one invoice notice',
            operateSuccess: 'Operate Success',
            hasWaitingForApproval: 'There are notifications to be reviewed',
            hasnotWaitingForApproval: 'There is no notification to be reviewed',
            cityName: 'City Name',
            batchDownloadScope: 'Download Scope',
            compensationFolder: 'Compensation Folder',
            whetherRejectInvoiceNotice: 'Are you sure you want to reject?',
            shipperEmpty: 'Please select shipper',
            paymentPlanTemplateDownload: 'PaymentPlan Template Download',
            discountCategory: 'Discount Type',
            sellOutDiscountCategory: 'Sell Out Discount Type',
            sellInDiscountCategory: 'Sell In Discount Type',
            addNewDiscountCategory: 'Add Discount Type',
            discountCategoryBeEmpty: 'Sell out  discount type cannot be empty',
            sellInDiscountCategoryLength: 'Sell out discount type cannot be more than 64 characters',
            sellInDiscountCategoryBeEmpty: 'Sell in discount type cannot be empty',
            discountCategoryLength: 'Sell in discount type cannot be more than 64 characters',
            compensationDiscountBeEmpty: 'compensation discount type cannot be empty',
            whetherDeleteDiscountCategory: 'whether delete discount type?',
            compensationDiscountType: 'compensation discount type'
        }
    }
}
export default certificate



// WEBPACK FOOTER //
// ./src/locale/modules/certificate.js